const config = {
    id: 14,
    name: "地址电话",
    type: 1,
    module_code: "contact_info",
    icon: "icon-tms-contact_info",
    font_icon: "&#xe6d6;",
    style_type: 1,
    link_type: 0,
    property_data: {
        is_map_show: 0,
        is_mobile_show: 0,
        latitude: 30.297612,
        longitude: 120.047646,
        map_icon: "https://img.mockuai.com/tms/2018/1/17/upload_007ade71fde095e383667e3a0f7a7831.png",
        mobile_icon: "https://img.mockuai.com/tms/2018/1/17/upload_d24253e96d8a3843fdd62cf444b02352.png"
    }
};
export default config;